module.exports = __webpack_public_path__ + "assets/icon_return.e43488a9.svg";